"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FindSchoolsStrategyEnum = void 0;
var FindSchoolsStrategyEnum;
(function (FindSchoolsStrategyEnum) {
  /** Те, в которых я только владелец */
  FindSchoolsStrategyEnum["owned"] = "owned";
  /** Те, в которых я участник любого типа */
  FindSchoolsStrategyEnum["participant"] = "participant";
  /** Те, в которых я не владелец ( = ученик + учитель) */
  FindSchoolsStrategyEnum["not_owned"] = "not_owned";
  /** Те, в которых я только ученик */
  FindSchoolsStrategyEnum["student"] = "student";
  /** Те, в которых я только препод */
  FindSchoolsStrategyEnum["teacher"] = "teacher";
  /** Добавленные в избранное */
  FindSchoolsStrategyEnum["favorites"] = "favorites";
  /** Поиск для библиотеки = промодерированные публичные */
  FindSchoolsStrategyEnum["library"] = "library";
})(FindSchoolsStrategyEnum = exports.FindSchoolsStrategyEnum || (exports.FindSchoolsStrategyEnum = {}));
